import Header from "../../components/Header";
import {
  View,
  Text,
  ScrollView,
  Pressable,
  StyleSheet,
  useWindowDimensions,
} from "react-native";
import {
  Provider as ProviderPaper,
  ActivityIndicator,
} from "react-native-paper";
import { useState } from "react";
import { usebrand } from "./useBrand";
import "react-color-palette/css";
import PickerColorHex from "../../components/PickerColorHex";
import ViewportProvider from "../../hooks/ViewPortProvider";
import { UploadImages } from "../../components/UploadImages";
import { CustomFont } from "./CustomFont";
import { InputCustomNumeric } from "./InputCustomNumeric";
import { ADMIN_COLORS, ADMIN_FONT } from "../../config/theme/adminColors";
import {
  SectionCard,
  Field,
  FieldLabel,
  Row,
  Col,
} from "../AdminPanel/Products/formStyles";

export function Brand({ navigation }) {
  const {
    primaryColor,
    setPrimaryColor,
    secondaryColor,
    setSecondaryColor,
    show,
    handleShowPicker,
    isLoadingCustomInfo,
    valueBorderRadius,
    setValueBorderRadius,
    isLoadingColorInfo,
  } = usebrand();

  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const [isSave, setIsSave] = useState(false);
  function handleSave(newValueState) {
    setIsSave(newValueState);
    setTimeout(() => {
      setIsSave(false);
    }, 2000);
  }

  const loading = isLoadingCustomInfo || isLoadingColorInfo;

  return (
    <ViewportProvider>
      <ProviderPaper>
        <View style={{ flex: 1, backgroundColor: ADMIN_COLORS.surfaceSubtle }}>
          <Header navigation={navigation} isAdminPage />

          <ScrollView contentContainerStyle={styles.scrollContent}>
            <View style={styles.page}>
              {/* Cabeçalho da página */}
              <View style={styles.headerBlock}>
                <Text style={[styles.title, isMobile && { fontSize: 24 }]}>
                  Marca
                </Text>
                <Text style={styles.subtitle}>
                  Personalize a identidade visual da sua marca — favicon, cores,
                  botões e tipografia.
                </Text>
              </View>

              {loading ? (
                <View style={styles.loadingBox}>
                  <ActivityIndicator color={ADMIN_COLORS.teal} size="large" />
                </View>
              ) : (
                <>
                  {/* Identidade visual */}
                  <SectionCard
                    title="Identidade visual"
                    subtitle="Ícone exibido na aba do navegador (favicon)."
                  >
                    <View style={styles.inlineField}>
                      <FieldLabel tooltip="Favicon é a pequena imagem que aparece na aba do navegador ao lado do título da página. Tamanho recomendado: 48x48px, limitado a 2MB. Apenas imagens .png são aceitas.">
                        Favicon (PNG)
                      </FieldLabel>
                      <UploadImages fileType="favIcon" />
                    </View>
                  </SectionCard>

                  {/* Cores */}
                  <SectionCard
                    title="Cores"
                    subtitle="Cores usadas nos elementos de destaque do aplicativo."
                  >
                    <Row>
                      <Col>
                        <Field style={{ marginBottom: 0 }}>
                          <FieldLabel tooltip="A cor principal é a cor predominante que representa sua marca e é utilizada de forma consistente em elementos visuais como ícones de destaque e botões.">
                            Cor principal
                          </FieldLabel>
                          <PickerColorHex
                            colorName={primaryColor}
                            props={{
                              color: primaryColor,
                              onChange: setPrimaryColor,
                            }}
                            setShow={() =>
                              handleShowPicker(
                                "showPrimaryColor",
                                !show.showPrimaryColor,
                              )
                            }
                            isShowPicker={show.showPrimaryColor}
                            setChange={setPrimaryColor}
                          />
                        </Field>
                      </Col>
                      <Col>
                        <Field style={{ marginBottom: 0 }}>
                          <FieldLabel tooltip="A cor secundária complementa a cor principal e é usada para destacar elementos específicos, criar contraste e adicionar variedade ao design da sua marca.">
                            Cor secundária
                          </FieldLabel>
                          <PickerColorHex
                            colorName={secondaryColor}
                            props={{
                              color: secondaryColor,
                              onChange: setSecondaryColor,
                            }}
                            setShow={() =>
                              handleShowPicker(
                                "showSecondaryColor",
                                !show.showSecondaryColor,
                              )
                            }
                            isShowPicker={show.showSecondaryColor}
                            setChange={setSecondaryColor}
                          />
                        </Field>
                      </Col>
                    </Row>
                  </SectionCard>

                  {/* Botões */}
                  <SectionCard
                    title="Botões"
                    subtitle="Estilo dos botões exibidos no aplicativo."
                  >
                    <Field style={{ marginBottom: 0 }}>
                      <FieldLabel tooltip="O arredondamento dos botões define o quão arredondados serão os cantos dos botões, medido em pixels (px).">
                        Arredondamento dos botões (px)
                      </FieldLabel>
                      <InputCustomNumeric
                        value={valueBorderRadius}
                        onChangeText={(text) =>
                          setValueBorderRadius(
                            Number(text.replace(/[^0-9]/g, "")),
                          )
                        }
                      />
                    </Field>
                  </SectionCard>

                  {/* Tipografia */}
                  <SectionCard
                    title="Tipografia"
                    subtitle="Fontes e tamanhos aplicados nas telas visíveis para o usuário final."
                  >
                    <CustomFont />
                  </SectionCard>

                  {/* Ação */}
                  <View style={styles.saveRow}>
                    <Pressable
                      onPress={() => handleSave(true)}
                      style={({ hovered }) => [
                        styles.primaryBtn,
                        isSave && { backgroundColor: ADMIN_COLORS.success },
                        hovered &&
                          !isSave && {
                            backgroundColor: ADMIN_COLORS.accentDark,
                          },
                      ]}
                    >
                      <Text style={styles.primaryBtnText}>
                        {isSave ? "Salvo!" : "Salvar"}
                      </Text>
                    </Pressable>
                    <Text style={styles.autosaveHint}>
                      As alterações são salvas automaticamente.
                    </Text>
                  </View>
                </>
              )}
            </View>
          </ScrollView>
        </View>
      </ProviderPaper>
    </ViewportProvider>
  );
}

const styles = StyleSheet.create({
  scrollContent: {
    flexGrow: 1,
    backgroundColor: ADMIN_COLORS.surfaceSubtle,
    padding: 24,
    alignItems: "center",
  },
  page: {
    width: "100%",
    maxWidth: 720,
  }, 
  headerBlock: {
    marginBottom: 20,
  },
  title: {
    fontFamily: ADMIN_FONT,
    fontSize: 28,
    fontWeight: "700",
    color: ADMIN_COLORS.ink,
  },
  subtitle: {
    fontFamily: ADMIN_FONT,
    fontSize: 14,
    color: ADMIN_COLORS.muted,
    marginTop: 4,
  },
  loadingBox: {
    paddingVertical: 80,
    alignItems: "center",
    justifyContent: "center",
  },
  inlineField: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  saveRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 14,
    flexWrap: "wrap",
    marginTop: 4,
  },
  primaryBtn: {
    height: 44,
    borderRadius: 10,
    paddingHorizontal: 24,
    backgroundColor: ADMIN_COLORS.teal,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  primaryBtnText: {
    fontFamily: ADMIN_FONT,
    fontSize: 15,
    fontWeight: "600",
    color: "#FFFFFF",
  },
  autosaveHint: {
    fontFamily: ADMIN_FONT,
    fontSize: 13,
    color: ADMIN_COLORS.muted,
  },
});
